import { useEffect } from "react";

// EmbedSocial Google Reviews widget.
const WIDGET_REF = "f8ae424c469cd409ea1334b83d5fd1ea5ac14f55";
const SCRIPT_ID = "EmbedSocialHashtagScript";

const widgetHTML = `<div class="embedsocial-hashtag" data-ref="${WIDGET_REF}"><a class="feed-powered-by-es feed-powered-by-es-feed-img es-widget-branding" href="https://embedsocial.com/google-reviews-widget/" target="_blank" rel="noopener" title="Embed Google reviews"><img src="https://embedsocial.com/cdn/icon/embedsocial-logo.webp" alt="EmbedSocial"><div class="es-widget-branding-text">Embed Google reviews</div></a></div>`;

export const GoogleReviews = () => {
  useEffect(() => {
    // Re-inject the loader so the widget is (re)scanned on client-side navigation.
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();
    const js = document.createElement("script");
    js.id = SCRIPT_ID;
    js.src = "https://embedsocial.com/cdn/ht.js";
    js.async = true;
    document.head.appendChild(js);
  }, []);

  return (
    <div
      data-testid="google-reviews-widget"
      className="min-h-[200px]"
      dangerouslySetInnerHTML={{ __html: widgetHTML }}
    />
  );
};

export default GoogleReviews;
